






















































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
//import config from '../../config'
import Initialize from "@/consoleapi/api/initialize";

@Component
export default class RegisterConfirm extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public companyName!: string;
    @Prop() public address!: string;
    @Prop() public phoneNumber!: string;

    //public confirm = false;

    @Emit()
    public inputConfirmEmit(inputConfirm: boolean) {
        inputConfirm;
    }

    register() {
        const initialize = new Initialize();
        initialize.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        initialize.post(
            this.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME)),
            this.name,
            this.kana,
            this.phoneNumber,
            this.address,
            this.companyName
        ).then(response => {
            this.$router.push('/register/call');
        }).catch(error => {
            //console.log(error.response);
            alert('登録に失敗しました。');
            return;
        })
    }
}
